import React, { useEffect, useState } from 'react'
import AresNavBar from '../Layout/NavBar/NavBar'
import SideBar from '../Layout/SideBar/SideBar'
import client from "../../services/Api";
import { ModalManager } from 'react-dynamic-modal';

import './index.css'
import FirmwareTable from './FirmwareTable';
import { Spinner } from 'react-bootstrap';
import FirmwareModal from './FirmwareModal';
import Button from 'react-bootstrap/Button'
import { MdSystemUpdateAlt } from 'react-icons/md';

export default function UpdateFirmware() {
  const [firmwares, setFirmwares] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    init()
  }, [])//eslint-disable-line react-hooks/exhaustive-deps

  async function init() {
    loadData()
  }

  const loadData = async () => {
    try {
      setLoading(true);
      const response = await client.get('/api/firmwares');
      setFirmwares(response.data)
      setLoading(false);
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  }


  function openFirmwareUpdate(notes) {
    ModalManager.open(<FirmwareModal firmwares={firmwares} notes={notes} onSave={loadData} />)
  }

  function renderLoading() {
    return (
      <div className="center-page">
        <Spinner animation="border" />
      </div>
    )
  }

  return (
    <div className='UpdateFirmware sidenav-margin'>
      <AresNavBar />
      <SideBar />

      <div className="content">
        <div className="container-header">
          <h1>Firmwares</h1>
          {firmwares && <span className='version'>Versão atual: {firmwares.length > 0 ? firmwares[0].version : '--'}</span>}
        </div>
        {loading ?
          renderLoading()
          :
          firmwares &&
          <div className='firmware-table'>
            <>
              <Button
                onClick={() => {
                  openFirmwareUpdate()
                }}
                className="button-add-version"
              >
                Adicionar nova versão
              <MdSystemUpdateAlt />
              </Button>
              <FirmwareTable firmwares={firmwares} callbackNotes={openFirmwareUpdate} />
            </>
          </div>
        }
      </div>

    </div>
  )
}
